<template>
  <div :class="{ quotePage: isRedesignedPage }">
    <template v-if="isRedesignedPage">
      <div class='quoteSubheader'>
        <div>{{$t("text.page8_subheader1")}}</div>
        <div>{{$t("text.page8_subheader2")}}</div>
      </div>
      <div class='quoteAssistance'>{{$t("text.page8_emergencyassistance")}}</div>
      <div class='quoteCardsSection' :style="{ gridTemplateColumns: 'repeat(' + desktopProducts.length + ', minmax(0, 384px))' }">
        <div v-for="product in desktopProducts" :key="'b-'+product.Product.ProductCode" class='quoteBadgeCell'>
          <div v-if="product.recommended === true" class='quoteItemRecommended'>
            <img src="../assets/images/recommended_lightbulb.svg" class="recommendedIcon" alt="" />
            {{ $t('text.recommended') }}
          </div>
        </div>
        <QuotePlanCard v-for="product in desktopProducts" :key="'d-'+product.Product.ProductCode" :product="product" :show-badge="false" @select="onSelect" @more-details="onMoreDetails" />
      </div>
      <div id='myCarousel' class='d-md-none quoteCardsStack' tabindex='-1'>
        <div v-for="product in displayProducts" :key="'m-'+product.Product.ProductCode" class='quoteRecommendedWrapper'>
          <div v-if="product.recommended === true" class='quoteItemRecommended'>
            <img src="../assets/images/recommended_lightbulb.svg" class="recommendedIcon" alt="" />
            {{ $t('text.recommended') }}
          </div>
          <QuotePlanCard :product="product" :show-badge="false" @select="onSelect" @more-details="onMoreDetails" />
        </div>
      </div>
      <div v-if="annualProducts.length" class='quoteAnnualSection'>
        <div class='quoteAnnualRule'></div>
        <button
          type='button'
          class='quoteAnnualHeader'
          :aria-expanded="annualOpen ? 'true' : 'false'"
          aria-controls='quoteAnnualCards'
          @click="annualOpen = !annualOpen"
        >
          <span class='quoteAnnualText'>
            <span class='quoteAnnualQuestion'>{{ annualCopy.question }}</span>
            <span class='quoteAnnualExplore'>{{ annualCopy.explore }}</span>
          </span>
          <img src="../assets/images/chevron_down_red.svg" class="accordionChevron" :class="{ open: annualOpen }" alt="" />
        </button>
        <div v-if="annualOpen" id='quoteAnnualCards' class='quoteAnnualCards'>
          <QuotePlanCard v-for="product in annualProducts" :key="'a-'+product.Product.ProductCode" :product="product" :show-badge="false" @select="onSelect" @more-details="onMoreDetails" />
        </div>
        <div class='quoteAnnualRule'></div>
      </div>
    </template>
    <template v-else>
      <div class='row d-none d-md-flex'>
        <div v-if="this.$store.state.numberOfTravellers>1" class='textInstructions text-center col-12 col-sm-8 offset-sm-2'>
          <span v-if='this.$store.state.site==="cibc"||this.$store.state.wantsCancellation===true'>{{$t("text.page8_alltravellers")}}</span>
          <span v-else>{{$t("text.page8_alltravellersnm")}}</span>
        </div>
        <div class='col-12 col-md-6 col-lg-4 order-2 order-sm-1'>
          <div id='product2' class='quoteItem'>
            <div class='quoteItemRecommended'></div>
            <div class='quoteItemBox'>
              <div class='quoteItemTitle' style='line-height:50px;'><h2></h2></div>
              <div class='quoteItemPrice'></div>
              <div class='quoteItemDescription'>
                <p></p>
                <p></p>
                <p></p>
              </div>
              <button @click="changeStep($event,'next')" class='btn btn-select' aria-label="">{{$t('text.select')}}</button>
              <center>
                <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
              </center>
            </div>
          </div>
        </div>
        <div class='col-12 col-md-6 col-lg-4 order-1 order-sm-2'>
          <div id='product1' class='quoteItem'>
            <div class='quoteItemRecommended'></div>
            <div class='quoteItemBox quoteItemBoxHighlighted'>
              <div class='quoteItemTitle' style='line-height:50px;'><h2></h2></div>
              <div class='quoteItemPrice'></div>
              <div class='quoteItemDescription'>
                <p></p>
                <p></p>
                <p></p>
              </div>
              <button @click="changeStep($event,'next')" class='btn btn-select' aria-label=''>{{$t('text.select')}}</button>
              <center>
                <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
              </center>
            </div>
          </div>
        </div>
        <div class='col-12 col-md-6 col-lg-4 order-3'>
          <div id='product3' class='quoteItem'>
            <div class='quoteItemRecommended'></div>
            <div class='quoteItemBox'>
              <div class='quoteItemTitle my-auto'><h2></h2></div>
              <div class='quoteItemPrice'></div>
              <div class='quoteItemDescription'>
                <p></p>
                <p></p>
                <p></p>
              </div>
              <button @click="changeStep($event,'next')" class='btn btn-select' aria-label=''>{{$t('text.select')}}</button>
              <center>
                <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
              </center>
            </div>
          </div>
        </div>
      </div>
      <div class='d-md-none'>
        <carousel id='myCarousel' :navigationEnabled="true" :perPage="1" :minSwipeDistance=100>
          <slide>
            <div id='product1m' class='quoteItem'>
              <div class='quoteItemRecommended'></div>
              <div class='quoteItemBox'>
                <div class='quoteItemTitle' style='line-height:50px;'><h2></h2></div>
                <div class='quoteItemPrice'></div>
                <div class='quoteItemDescription'>
                  <p></p>
                  <p></p>
                  <p></p>
                </div>
                <button @click="changeStep($event,'next')" class='btn btn-select' aria-label="">{{$t('text.select')}}</button>
                <center>
                  <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
                </center>
              </div>
            </div>
          </slide>
          <slide v-if="this.$store.state.productCount>=2">
            <div id='product2m' class='quoteItem'>
              <div class='quoteItemRecommended'></div>
              <div class='quoteItemBox'>
                <div class='quoteItemTitle' style='line-height:50px;'><h2></h2></div>
                <div class='quoteItemPrice'></div>
                <div class='quoteItemDescription'>
                  <p></p>
                  <p></p>
                  <p></p>
                </div>
                <button @click="changeStep($event,'next')" class='btn btn-select' aria-label="">{{$t('text.select')}}</button>
                <center>
                  <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
                </center>
              </div>
            </div>
          </slide>
          <slide v-if="this.$store.state.productCount>=3">
            <div id='product3m' class='quoteItem'>
              <div class='quoteItemRecommended'></div>
              <div class='quoteItemBox'>
                <div class='quoteItemTitle my-auto'><h2></h2></div>
                <div class='quoteItemPrice'></div>
                <div class='quoteItemDescription'>
                  <p></p>
                  <p></p>
                  <p></p>
                </div>
                <button @click="changeStep($event,'next')" class='btn btn-select' aria-label=''>{{$t('text.select')}}</button>
                <center>
                  <a class='moreDetails' href="javascript:void(0);" aria-label="" @click='openCoverageDetails($event)'>{{$t('text.moredetails')}}</a>
                </center>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </template>
  </div>
</template>
<style>
  .quoteItem {
    min-width: 275px;
    padding: 15px;
  }
  .quoteItemRecommended {
    color: #336699;
    text-align:center;
    height:25px;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 15px;
  }
  .redesignedFont .quotePage {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }
  .redesignedFont .quoteSubheader {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 16px;
    line-height: 18px;
    font-weight: 400;
    color: #333333;
    text-align: center;
  }
  .redesignedFont .quoteAssistance {
    font-size: 16px;
    line-height: 18px;
    font-weight: 400;
    color: #333333;
    text-align: center;
  }
  @media (max-width: 767.98px) {
    .redesignedFont .quoteSubheader {
      font-size: 14px;
      line-height: 140%;
      text-align: left;
    }
    .redesignedFont .quoteAssistance {
      font-size: 14px;
      line-height: 140%;
      text-align: left;
    }
  }
  .redesignedFont .quoteItemRecommended {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 28px;
    margin: 0;
    color: #C41F3E;
    text-align: center;
    font-family: "Fira Sans", sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
  .redesignedFont .recommendedIcon {
    width: 11px;
    height: 14px;
    flex-shrink: 0;
  }
  .redesignedFont .quoteItem {
    min-width: 0;
    padding: 0;
  }
  .redesignedFont .quoteItemBox {
    min-height: 0;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 24px;
    background-color: #FFFFFF;
    border: 1px solid #BBBCBC;
    border-radius: 2px;
  }
  .redesignedFont .quoteItemBoxRecommended {
    border-color: #C41F3E;
  }
  .redesignedFont .quoteItemCategory {
    font-family: "Fira Sans", sans-serif;
    font-weight: 600;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #6F6F6F;
  }
  .redesignedFont .quoteItemTitle {
    text-align: left;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .redesignedFont .quoteItemTitle h2 {
    font-family: "Fira Sans", sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: #333333;
    margin: 0;
  }
  .redesignedFont .quoteItemPlanDescription {
    font-family: "Fira Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #333333;
    margin: 0;
  }
  .redesignedFont .quoteItemPrice {
    text-align: left;
    color: #333333;
    font-family: "Fira Sans", sans-serif;
    font-weight: 300;
    font-size: 36px;
    line-height: 41px;
  }
  .redesignedFont .quoteItemDivider {
    height: 1px;
    flex-shrink: 0;
    align-self: stretch;
    background-color: #BBBCBC;
  }
  .redesignedFont .quoteItemBenefits {
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: left;
  }
  .redesignedFont .quoteBenefitRow {
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }
  .redesignedFont .quoteBenefitRow .checkIcon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    margin-top: 3.5px;
  }
  .redesignedFont .quoteBenefitRow span {
    flex: 1;
    font-family: "Fira Sans", sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: #333333;
  }
  .redesignedFont .quoteItemAccordion {
    display: flex;
    flex-direction: row;
    gap: 8px;
    text-align: left;
  }
  .redesignedFont .accordionActiveBar {
    width: 3px;
    flex-shrink: 0;
    align-self: stretch;
    background-color: #C41F3E;
  }
  .redesignedFont .accordionBody {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .redesignedFont .accordionHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    text-align: left;
    font-family: "Fira Sans", sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: #333333;
  }
  .redesignedFont .accordionChevron {
    width: 16px;
    height: 8px;
    flex-shrink: 0;
    transition: transform 0.15s ease-in-out;
  }
  .redesignedFont .accordionChevron.open {
    transform: rotate(180deg);
  }
  .redesignedFont .accordionContent p {
    font-family: "Fira Sans", sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;
    color: #6F6F6F;
    margin: 0;
  }
  .redesignedFont .quoteItemActions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
  }
  .redesignedFont .quoteItemActions .btn-select {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background-color: #C41F3E;
    border: none;
    border-radius: 4px;
    height: 44px;
    width: auto;
    margin: 0;
    padding: 0 24px;
    font-family: "Fira Sans", sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: #FFFFFF;
  }
  .redesignedFont .quoteItemActions .btn-select:hover,
  .redesignedFont .quoteItemActions .btn-select:focus,
  .redesignedFont .quoteItemActions .btn-select:active {
    background-color: #C41F3E;
    border-color: #C41F3E;
    color: #FFFFFF;
    box-shadow: none;
  }
  .redesignedFont .quoteItemActions .btn-select:focus-visible {
    outline: 2px solid #1F2321;
    outline-offset: 2px;
  }
  .redesignedFont .quoteItemActions a.moreDetails,
  .redesignedFont .quoteItemActions a.moreDetails:visited,
  .redesignedFont .quoteItemActions a.moreDetails:active,
  .redesignedFont .quoteItemActions a.moreDetails:hover,
  .redesignedFont .quoteItemActions a.moreDetails:link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    color: #C41F3E;
    text-decoration: none;
    font-family: "Fira Sans", sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
  }
  .redesignedFont .quoteCardsSection {
    display: none;
  }
  .redesignedFont .quoteCardsStack {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .redesignedFont .quoteRecommendedWrapper {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .redesignedFont .quoteRecommendedWrapper .quoteItemRecommended {
    justify-content: flex-start;
    height: 16px;
  }
  .redesignedFont .quoteAnnualSection {
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-top: 16px;
  }
  .redesignedFont .quoteAnnualRule {
    height: 1px;
    background-color: #BBBCBC;
  }
  .redesignedFont .quoteAnnualHeader {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 4px 0;
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
    align-self: flex-start;
    font-family: "Fira Sans", sans-serif;
  }
  .redesignedFont .quoteAnnualText {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .redesignedFont .quoteAnnualQuestion {
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #333333;
  }
  .redesignedFont .quoteAnnualExplore {
    font-weight: 600;
    font-size: 15px;
    line-height: 17px;
    color: #C41F3E;
  }
  .redesignedFont .quoteAnnualCards {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  @media (min-width: 768px) {
    .redesignedFont .quoteCardsSection {
      display: grid;
      grid-template-rows: 28px auto;
      column-gap: 24px;
      align-items: start;
      justify-content: center;
    }
    .redesignedFont .quoteCardsStack {
      display: none;
    }
    .redesignedFont .quoteAnnualCards {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 24px;
      align-items: start;
    }
  }
  @media (max-width: 767.98px) {
    .redesignedFont .quotePage {
      gap: 16px;
    }
    .redesignedFont .quoteAnnualSection {
      padding-top: 0;
      gap: 16px;
    }
    .redesignedFont .quoteAnnualHeader {
      padding: 0;
      min-height: 36px;
    }
    .redesignedFont .quoteAnnualQuestion,
    .redesignedFont .quoteAnnualExplore {
      font-size: 14px;
      line-height: 16px;
    }
  }
  .quoteItemTitle {
    text-align:center;
    height: 75px;
  }
  .quoteItemTitle h2 {
    font-weight: bold;
    color: #333333;
    font-size: 16px;
  }
  .quoteItemPrice {
    font-size: 36px;
    font-weight:300;
  }
  .quoteItemPrice .price-asterisk {
    font-size: 0.6em;
    vertical-align: super;
    margin-left: 0.1em;
    line-height: 0;
  }
  .quoteItemBox{
    min-height: 425px;
    text-align:center;
    padding: 25px;
    
  }
  .quoteItemBoxHighlighted {
    background-color: #F5F5F5;
  }
  .quoteItemDescription {
    padding-top:15px;
    height:250px;
  }
  .btn-select {
    display: inline-block;
    background-color: #336699;
    border-radius: 3px;
    height: 40px;
    width: 114px;
    margin-bottom: 25px;
    font-family: Arial;
    color: white;
    vertical-align: middle;
    padding: 0.375rem 0.75rem;
  }
  a.moreDetails:visited,
  a.moreDetails:active,
  a.moreDetails:hover,
  a.moreDetails:link{
    color: #AF0B1C;
    text-decoration: underline;
    font-family:arial;
  }
  .VueCarousel-navigation-button {
    border: 1px solid #CCCCCC !important;

    width: 50px;
    height: 50px;
    border-radius:100px;
    background-color: white !important;  
    color: #FFFFFF;
  }

  .VueCarousel-navigation-next {
    right:40px !important;
    box-shadow: -5px 0px 5px #ccc;
  }
  .VueCarousel-navigation-prev {
    left:40px !important;
    box-shadow: 5px 0px 5px #ccc;
  }
  .VueCarousel-inner .quoteItemBox {
    border: 1px solid black;
  }
  .VueCarousel-inner .quoteItemDescription {
    height:200px;
  }
  .VueCarousel-navigation--disabled {
    opacity: 1 !important;
    color: #CCCCCC !important;
  }
</style>

<script>
import bus from "../utils/bus.js";
import { constructProducts, buildDisplayProducts } from "../utils/constructProducts.js";
import setActiveProduct from "../utils/setActiveProduct.js";
import { Carousel, Slide } from 'vue3-carousel';
import QuotePlanCard from "../components/QuotePlanCard.vue";

export default {
  components: {
    QuotePlanCard
  },
  computed: {
    isRedesignedPage() {
      return this.$route.meta.redesigned === true;
    },
    displayProducts() {
      return this.$store.state.displayProducts || [];
    },
    desktopProducts() {
      const products = [...this.displayProducts];
      if (products.length > 1) {
        [products[0], products[1]] = [products[1], products[0]];
      }
      return products;
    },
    annualCopy() {
      return String(this.$i18n.locale).toLowerCase().startsWith('fr')
        ? { question: "Vous pr\u00e9voyez plus d'un voyage cette ann\u00e9e?", explore: "D\u00e9couvrez les forfaits annuels" }
        : { question: "Planning more than one trip this year?", explore: "Explore Annual Plans" };
    },
    annualProducts() {
      const annualCodes = ["CIBCAnnual8Day", "CIBCIAnnual8Day", "CIBCAnnual18Day", "CIBCIAnnual18Day"];
      const displayed = new Set(this.displayProducts.map((product) => product.Product.ProductCode));
      const annualProducts = new Map();
      for (const category in this.$store.state.products) {
        for (const product of this.$store.state.products[category].Products || []) {
          const code = product.Product.ProductCode;
          if (annualCodes.includes(code) && !displayed.has(code) && !annualProducts.has(code)) {
            annualProducts.set(code, product);
          }
        }
      }
      return annualCodes.filter((code) => annualProducts.has(code)).map((code) => annualProducts.get(code));
    }
  },
  data() {
    return {
      annualOpen: false
    };
  },
  methods: {
    changeStep(event, targetStep) {
      let doValidation;
      if (targetStep === "next") {
        targetStep = this.$route.meta.nextStep;
        doValidation=true;
      } else {
        targetStep = this.$route.meta.previousStep;
        doValidation=false;
      }
      setActiveProduct(this, event.target.getAttribute("data-product"));

      bus.$emit("changeStep", this.$route.path, targetStep, doValidation);
    },
    openCoverageDetails(event) {
      for(const category in this.$store.state.products){
        for(const product of this.$store.state.products[category].Products){
          if(event.target.getAttribute("data-product")===product.Product.ProductCode){
            bus.$emit("openCoverageDetails", product);
          }
        }
      }
    },
    onSelect(product) {
      setActiveProduct(this, product.Product.ProductCode);
      bus.$emit("changeStep", this.$route.path, this.$route.meta.nextStep, true);
    },
    onMoreDetails(product) {
      bus.$emit("openCoverageDetails", product);
    }
  },
  created() {
    buildDisplayProducts(this);
  },
  mounted() {
    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}

    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      if(window.innerWidth<400){
        document.getElementById("myCarousel").focus();
      }
      else {
        document.getElementById("stepTitle").focus();
      }
    });

    if (!this.isRedesignedPage) {
      constructProducts(this);
    }
  }
};
</script>
